export default "__VITE_ASSET__8d2GkNj1__"